module.exports = __webpack_public_path__ + "static/media/ฉลู.81e9c5c8.jpg";